import { TOOL_CONFIRMATION_LABELS } from '../../ToolConfirmationCard.constants';

export const TOOL_CONFIRM_LABELS = {
  approve: TOOL_CONFIRMATION_LABELS.APPROVE,
  dismiss: TOOL_CONFIRMATION_LABELS.DECLINE,
  reasonPlaceholder: TOOL_CONFIRMATION_LABELS.REASON_PLACEHOLDER,
  reasonSubmit: TOOL_CONFIRMATION_LABELS.REASON_SUBMIT,
  reasonCancel: TOOL_CONFIRMATION_LABELS.REASON_CANCEL,
  slaGroupLabel: TOOL_CONFIRMATION_LABELS.SLA_GROUP_LABEL,
  slaGroupPlaceholder: TOOL_CONFIRMATION_LABELS.SLA_GROUP_PLACEHOLDER,
  slaGroupPrompt: TOOL_CONFIRMATION_LABELS.SLA_GROUP_PROMPT,
};
